import { IFormBuilderItemBase, IFormBuilderItemDataBase, TFormBuilderItem } from "./formBuilderItem";

type TFormBuilderInputType = "input";
export type TFormBuilderInputRole = "address" | "custom" | "email" | "first-name" | "last-name" | "phone";

export interface IFormBuilderInputSettings {
  label: string;
  placeholder: string;
  required: boolean;
  isNumeric?: boolean;
}

export interface IFormBuilderInputData extends IFormBuilderItemDataBase {
  type: TFormBuilderInputType;
  role: TFormBuilderInputRole;
  settings: IFormBuilderInputSettings;
}

export interface IFormBuilderInput extends IFormBuilderItemBase {
  data: IFormBuilderInputData;
}

export type TFormBuilderInputSettings = IFormBuilderInput["data"]["settings"];

export function isFormBuilderInputItem(item: TFormBuilderItem): item is IFormBuilderInput {
  return item.data.type === "input";
}

export function isFormBuilderInputType(value: string): value is TFormBuilderInputType {
  return value === "input";
}

export function isFormBuilderInputRole(value: string): value is TFormBuilderInputRole {
  return (
    value === "address" ||
    value === "custom" ||
    value === "email" ||
    value === "first-name" ||
    value === "last-name" ||
    value === "phone"
  );
}

export function getFormBuilderInputDomType(role: TFormBuilderInputRole, settings: IFormBuilderInputSettings): string {
  switch (role) {
    case "email":
      return "email";
    case "phone":
      return "tel";
    case "custom":
      return settings.isNumeric ? "number" : "text";
    default:
      return "text";
  }
}

export function formBuilderGenerateDefaultAddressInput(): IFormBuilderInput {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "input",
      role: "address",
      settings: {
        label: "Address", // TODO: Translation
        placeholder: "Enter address", // TODO: Translation
        required: true,
      },
    },
  };
}

export function formBuilderGenerateDefaultCustomInput(): IFormBuilderInput {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "input",
      role: "custom",
      settings: {
        label: "Input", // TODO: Translation
        placeholder: "Enter value", // TODO: Translation
        required: true,
        isNumeric: false,
      },
    },
  };
}

export function formBuilderGenerateDefaultEmailInput(): IFormBuilderInput {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "input",
      role: "email",
      settings: {
        label: "Email", // TODO: Translation
        placeholder: "Enter email", // TODO: Translation
        required: true,
      },
    },
  };
}

export function formBuilderGenerateDefaultFirstNameInput(): IFormBuilderInput {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "input",
      role: "first-name",
      settings: {
        label: "First name", // TODO: Translation
        placeholder: "Enter first name", // TODO: Translation
        required: true,
      },
    },
  };
}

export function formBuilderGenerateDefaultLastNameInput(): IFormBuilderInput {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "input",
      role: "last-name",
      settings: {
        label: "Last name", // TODO: Translation
        placeholder: "Enter last name", // TODO: Translation
        required: true,
      },
    },
  };
}

export function formBuilderGenerateDefaultPhoneInput(): IFormBuilderInput {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "input",
      role: "phone",
      settings: {
        label: "Phone", // TODO: Translation
        placeholder: "Enter phone number", // TODO: Translation
        required: true,
      },
    },
  };
}